import { useQuery } from '@apollo/client'
import { Modal, Paper, Slide, useMediaQuery, useTheme } from '@material-ui/core'
import { Pagination } from '@material-ui/lab'
import { useMemo, useState } from 'react'
import { toast } from 'react-toastify'

import { CHECK_STATUS_QUERY } from '../../graphql/checkStatus'
import { getDirection } from '../../localization'
import { CheckStatus } from '../../types/checkStatus'
import CheckStatusTable from './MonitoringFormList/CheckStatusTable'
import useStyles from './styles/index.styles'

interface CheckStatusModalProps {
  isOpen: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
  reservationNumber: string
}

const CheckStatusModal: React.FC<CheckStatusModalProps> = ({
  isOpen,
  onClose,
  reservationNumber
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const perPage = 5
  const [count, setcount] = useState<number>(0)
  const [page, setPage] = useState<number>(1)

  const numberOfPages = useMemo(() => Math.ceil(count / perPage), [count])

  const { data, loading, refetch } = useQuery<{
    checkStatus: CheckStatus
  }>(CHECK_STATUS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    variables: {
      reservationNumber: reservationNumber
    },
    onCompleted: (res) => {
      setcount(res.checkStatus.rooms.length)
    },
    onError: (err) => {
      toast.error(err.message)
    }
  })

  return (
    <Modal dir={getDirection()} open={isOpen} onClose={onClose}>
      <Slide direction="down" in={isOpen}>
        <Paper className={classes.paper}>
          <CheckStatusTable
            data={data?.checkStatus}
            loading={loading}
            refetch={refetch}
          />
          <div className={classes.paginationContainer}>
            <Pagination
              page={page}
              count={numberOfPages}
              color="primary"
              size={isSmallScreen ? 'small' : 'medium'}
              onChange={(_, value) => setPage(value)}
            />
          </div>
        </Paper>
      </Slide>
    </Modal>
  )
}

export default CheckStatusModal
